import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiAppearanceViewComponent } from '@fi-app/appearance/appearance-view.component';
import { WidgetService } from '@fi-app/widget/widget.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { WidgetAdministrateService } from '@fi-app/widget/widget-administrate.service';
import { ModuleType } from '@fi-shared/types/module-type';
import { ListViewSettingsService } from '@fi-app/utilities/fi-services/list-view-settings.service';
import { FiCustomerSettingsService } from '@fi-app/appearance/customer-settings/customer-settings.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { WidgetAdministrateModel } from '@fi-app/widget/model/widget-administrate.model';

export const FiAppearanceViewState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.View,
    url: '/',
    component: FiAppearanceViewComponent,
    resolve: {
        pageTitle: [PageTitleService, FiAppearanceViewStateResolvePageTitle],
    },
};

export function FiAppearanceViewStateResolvePageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByTextId('common.appearance');
}
